import { render, staticRenderFns } from "./QuantidadesCompra.vue?vue&type=template&id=dcd46ad6"
import script from "./QuantidadesCompra.vue?vue&type=script&lang=js"
export * from "./QuantidadesCompra.vue?vue&type=script&lang=js"
import style0 from "./QuantidadesCompra.vue?vue&type=style&index=0&id=dcd46ad6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports